import styles from './body.module.scss';
import React, { FC } from 'react';

const Body: FC = (props) => {
    return (
        <>
            <article className={styles.body}>{props.children}</article>
            {/* <div className={styles.browseOpen}></div> */}
        </>
    );
};

export default Body;
